<ng-container [formGroup]="inputFormGroup" *ngIf="inputFormGroup.value.IsApplicable">
  <td>
    <phx-form-control [layoutType]="layoutType.InputOnly" [control]="inputFormGroup.get('FullName')" [editable]="false" viewModeText="{{ inputFormGroup.value.FullName }}"></phx-form-control>
  </td>
  <td>
    <phx-form-control [layoutType]="layoutType.InputOnly"
      [control]="inputFormGroup.get('CommissionRateHeaderId')"
      [editable]="readOnlyStorage.IsCommissionsEditable && inputFormGroup.value.CommissionRates.length > 1 && checkPtFiledAccessibility('WorkOrderVersion.WorkOrderVersionCommissions','CommissionRateHeaderId')">
      <!-- control -->
      <app-phx-select-box [formControl]="inputFormGroup.get('CommissionRateHeaderId')"
        [items]="inputFormGroup.get('CommissionRates').value" textField="DisplayText"
        valueField="CommissionRateHeaderId">
      </app-phx-select-box>
      <!-- view mode -->
      <ng-container view-mode>
        <app-commission-picker-view-mode [commissionRateHeaderId]="inputFormGroup.value.CommissionRateHeaderId"
          [commissionRates]="inputFormGroup.value.CommissionRates" [showTooltip]="false">
        </app-commission-picker-view-mode>
      </ng-container>
    </phx-form-control>
  </td>
  <td *ngIf="useCommissionMarginSplitPercentage">
    <phx-form-control [layoutType]="layoutType.InputOnly"
      [control]="inputFormGroup.get('MarginSplitPercentage')"
      [editable]="readOnlyStorage.IsCommissionsEditable && checkPtFiledAccessibility('WorkOrderVersion.WorkOrderVersionCommissions','MarginSplitPercentage')"
      viewModeText="{{ inputFormGroup.value.MarginSplitPercentage | phxPercentWithDecimals:'1.2-2' }}">
      <input [formControl]="inputFormGroup.get('MarginSplitPercentage')" type="text" [ngClass]="isMarginSplitPercentageInvalid() ? 'form-control ng-invalid' : 'form-control'"
        phxFloatBetweenInput='{"from":0, "to":999999.99, "decimalplaces":2}'/>
    </phx-form-control>
  </td>
  <td *ngIf="showCommissionRateColumn">
    <phx-form-control [layoutType]="layoutType.InputOnly" [control]="inputFormGroup.get('DisplayCommissionRatePercentage')" [editable]="false"
      viewModeText="{{ inputFormGroup.value.DisplayCommissionRatePercentage | phxPercentWithDecimals:'1.2-2' }}">
    </phx-form-control>    
  </td>
  <td *ngIf="showCommissionRateColumn">
    <button id="overrideButton-{{index}}" [ngClass]="this.inputFormGroup.value.IsOverridden ? 'btn btn-pressed' : 'btn btn-default'" type="button" (click)="overrideCommissionRate()"
      [disabled]="!(readOnlyStorage.IsCommissionsEditable && checkPtFiledAccessibility('WorkOrderVersion.WorkOrderVersionCommissions','CommissionRatePercentage') && inputFormGroup.value.CommissionRatePercentage)">
      <i class="material-icons">edit</i>
      <app-phx-tool-tip *ngIf="this.inputFormGroup.value.IsOverridden" position="right" targetId="#overrideButton-{{index}}">
        <div class="text-left">
          <div>Override by {{ this.inputFormGroup.value.OverrideByFullName }} on {{ this.inputFormGroup.value.OverrideDatetime | date: phxConstants.DateFormat.mediumDate }}.</div>
          <div>Reason: {{ this.inputFormGroup.value.OverrideReason }}</div>
        </div>
      </app-phx-tool-tip>
    </button>
  </td>
</ng-container>

<app-phx-modal #modalCommissionRateOverride  title="Commission Rate Override" [buttons]="overrideButtons">
  <form *ngIf="overrideFormGroup" [formGroup]="overrideFormGroup">
    <div class="modal-md form-horizontal">
      <phx-form-control labelText="Commission Rate (system-calculated)" [control]="overrideFormGroup.get('CalculatedCommissionRatePercentage')"
        [editable]="false" viewModeText="{{ overrideFormGroup.value.CalculatedCommissionRatePercentage | phxPercentWithDecimals:'1.2-2' }}">
      </phx-form-control>
      <phx-form-control labelText="Commission Rate (override)" [control]="overrideFormGroup.get('OverridenCommissionRatePercentage')">
        <input [formControl]="overrideFormGroup.get('OverridenCommissionRatePercentage')" type="text" class="form-control" phxFloatBetweenInput='{"from":0, "to":999999.99, "decimalplaces":2}'/>
      </phx-form-control>
      <phx-form-control labelText="Override Reason" [control]="overrideFormGroup.get('OverrideReason')">
        <textarea rows="3" style="resize: none" [formControl]="overrideFormGroup.get('OverrideReason')" class="form-control"></textarea>
      </phx-form-control>
    </div>    
  </form>
</app-phx-modal>